import React from 'react'
import styled from 'styled-components'
import backgroundImageMobile from '../images/background-image-single.jpg'
import backgroundImageDesktop from '../images/background-image-triple.jpg'
import { TabletDeviceWidth } from '../lib/constants'

const ImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-image: url(${backgroundImageDesktop});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (max-width: ${TabletDeviceWidth}px) {
    background-image: url(${backgroundImageMobile});
  }
`

const FeaturedImage = () => <ImageDiv></ImageDiv>

export default FeaturedImage
